import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PipefyLogoutGuard } from '@app/guards';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import { AuthRegisterComponent } from './auth-register/auth-register.component';
import { AuthPasswordNewComponent } from './auth-password-new/auth-password-new.component';
import { AuthPasswordEditComponent } from './auth-password-edit/auth-password-edit.component';
import { AuthEmailConfirmationComponent } from './auth-email-confirmation/auth-email-confirmation.component';
import { AuthOnboardingComponent } from '@app/pages/auth/auth-onboarding/auth-onboarding.component';

const routes: Routes = [
  { path: 'entrar', component: AuthLoginComponent, data: { title: 'route.login' }, canActivate: [PipefyLogoutGuard] },
  { path: 'cadastro', component: AuthRegisterComponent, data: { title: 'route.register' }, canActivate: [PipefyLogoutGuard] },
  { path: 'cadastro/:token', component: AuthRegisterComponent, data: { title: 'route.register' }, canActivate: [PipefyLogoutGuard] },
  { path: 'recuperar-senha', component: AuthPasswordNewComponent, data: { title: 'route.recoverPassword' } },
  { path: 'recuperar-senha/:token', component: AuthPasswordEditComponent, data: { title: 'route.recoverPassword' } },
  { path: 'confirmacao', component: AuthEmailConfirmationComponent, data: { title: 'route.confirmation' } },
  { path: 'onboarding', component: AuthOnboardingComponent, data: { title: 'route.onboarding' } }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
